import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string?} State */
const initialState = null;

const selectOne = (_, { payload: language }) => language;

export default createReducer(initialState, {
  [types.SELECT_LANGUAGE]: selectOne,
});
